// Support component names relative to this directory
const ReactRailsUJS = require('react_ujs');

if (process.env.npm_lifecycle_script !== 'jest') {
  // This doesn't work when running Jest. The if above is a hackish way to try
  // to work around the issue.
  const componentRequireContext = require.context('../components', true);
  ReactRailsUJS.useContext(componentRequireContext);
}

export default ReactRailsUJS;
